<script lang="ts" setup>
// Delete-product confirmation. Mirrors DeleteProjectModal's inline pattern; the parent owns the
// mutation and visibility so it can keep the modal open / surface errors. Copy spells out the dual
// effect — the product is hard-deleted, its master project is soft-deleted (restorable).
defineProps<{
  show: boolean;
  productName: string;
  masterProjectName: string;
  pending?: boolean;
}>();

const emit = defineEmits<{
  confirm: [];
  cancel: [];
}>();
</script>

<template>
  <template v-if="show">
    <div
      class="modal fade show"
      style="display: block"
      tabindex="-1"
      @click.self="emit('cancel')"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title text-danger">
              <i class="bi bi-exclamation-triangle me-2"></i>Delete Product
            </h2>
            <button type="button" class="btn-close" :disabled="pending" @click="emit('cancel')"></button>
          </div>
          <div class="modal-body">
            <p>Delete <strong>{{ productName }}</strong>?</p>
            <p class="text-muted mb-0">
              This permanently removes the product and moves its master project
              <strong>{{ masterProjectName }}</strong> to Deleted — restorable from
              Projects &rsaquo; Recycle Bin. This can't be undone for the product itself.
            </p>
          </div>
          <div class="modal-footer">
            <button class="bb-btn-cancel" :disabled="pending" @click="emit('cancel')">Cancel</button>
            <button class="btn btn-danger" :disabled="pending" data-cy="confirm-delete-product" @click="emit('confirm')">
              <span v-if="pending" class="spinner-border spinner-border-sm me-1" role="status"></span>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" @click="emit('cancel')"></div>
  </template>
</template>
